import React, { useState, useEffect } from "react";
import { goToNextStep, goBackToPrevStep, restart } from "context/AppContext/actions";
import { ButtonContinue, ButtonGoBack } from "components/Button";
import { useAppContext } from "context/AppContext/AppContext";
import Option from "components/Option";
import StepQuestionWrap from "components/styled/StepQuestionWrap.styled";
import StepQuestionText from "components/styled/StepQuestionText.styled";
import { motion } from "framer-motion";

const StepQuestion = () => {
  const { state, dispatch } = useAppContext();
  const { currentStep, scenario } = state;

  const [currentSelected, setCurrentSelected] = useState(null);
  const [nextStepId, setNextStepId] = useState(null);

  const handleOptionOnClick = (optionId, nextStepId) => {
    setCurrentSelected(optionId);
    setNextStepId(nextStepId);
  };

  const handleGoBack = () => {
    if (currentStep.id === scenario.firstStepId) {
      dispatch(restart());
    } else {
      dispatch(goBackToPrevStep());
    }
  };

  const handleContinue = () => {
     dispatch(goToNextStep(nextStepId));
  }

  useEffect(() => {
    window.scroll({left: 0, top: 0});
  }, [currentStep]);

  const BackgroundImage = currentStep.backgroundImage;

  const list = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };
  
  const item = {
    hidden: { scale: 0 },
    show: { scale: 1 },
  };

  return (
    <StepQuestionWrap>
       {currentStep.backgroundImage && <div className="background-image">{< BackgroundImage />}</div>}
      <div className="content">
        <StepQuestionText className="question-text" dangerouslySetInnerHTML={{ __html: currentStep.text }} initial={{opacity: 0, y:40}} animate={{opacity: 1, y:0}} transition={{duration: 0.3}} as={motion.div}></StepQuestionText>
        <motion.div className="options" variants={list} initial="hidden" animate="show">
          {currentStep?.options.map((option) => (
           <motion.div  key={option.id} variants={item} transition={{duration: 0.3}}> <Option key={option.id} {...option} selected={currentSelected === option.id} onClick={() => handleOptionOnClick(option.id, option.nextStepId)} /></motion.div>
          ))}
        </motion.div>
        <motion.div className="buttons" initial={{opacity: 0, y:40}} animate={{opacity: 1, y:0}} transition={{duration: 0.3, delay: 1}}>
          <ButtonGoBack onClick={handleGoBack} />
          <ButtonContinue disabled={!nextStepId} onClick={handleContinue} />
        </motion.div>
      </div>
    </StepQuestionWrap>
  );
};

export default StepQuestion;
